export const STRIPE_SCRIPT_SRC = 'https://js.stripe.com/v3';

export const PAYMENT_OS_SCRIPT_SRC = 'https://js.paymentsos.com/v3/latest/secure-fields.min.js';

export const PAYMENT_OS_LOADED_RETRY = 3;
